// extracted by mini-css-extract-plugin
export default {"issuerFooter":"YbJbTQKmn0Kke4ZDq9tJ","issuerFooterRow":"CmbQj0MRcIC7cCDjHnJZ","issuerFooterPageTitle":"FgPkYOcXaNj_Bf7Nq0O9"};